import(/* webpackMode: "eager", webpackExports: ["WorkSidebar"] */ "/app/app/(work)/layout-left/work-sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DashSidebar"] */ "/app/components/dashboard-sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/edil-ozi/command-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/edil-ozi/main-nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/edil-ozi/mobile-nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/edil-ozi/mode-toggle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SidebarProvider","SidebarInset","SidebarDashset"] */ "/app/components/ui/sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.4.10_@babel+core@7.28.5_@opentelemetry+api@1.9.0_react-dom@19.0.0-rc-45804af1-2024102_nywpvwtolcultbit5uudreidbm/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["toast","error","warning","success"] */ "/app/node_modules/.pnpm/sonner@1.7.4_react-dom@19.0.0-rc-45804af1-20241021_react@19.0.0-rc-45804af1-20241021__react@19.0.0-rc-45804af1-20241021/node_modules/sonner/dist/index.mjs");
